module.exports = "/assets/ad8a13555dfea9a96a9bc501421bedac.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/4T.png
// module id = 1045
// module chunks = 0